import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { AuthTokenState } from 'src/app/auth/state/auth-token.state';
import { AddLineItemToShoppingCart } from 'src/app/shopping-cart/actions/shopping-cart.actions';
const ɵ0 = (state) => state.productDetails.details, ɵ1 = (state) => state.core.dictionaries.currencySignsMap, ɵ2 = (state) => state.shoppingCart.addLineItemPending;
export class BottomAnchorComponent {
    constructor(store) {
        this.store = store;
    }
    ngOnInit() {
    }
    addToCart() {
        this.store.dispatch(new AddLineItemToShoppingCart(this.selectedVariant.sku, 1));
    }
}
tslib_1.__decorate([
    Select(ɵ0),
    tslib_1.__metadata("design:type", Observable)
], BottomAnchorComponent.prototype, "product$", void 0);
tslib_1.__decorate([
    Select(AuthTokenState.isLogged),
    tslib_1.__metadata("design:type", Observable)
], BottomAnchorComponent.prototype, "isLogged$", void 0);
tslib_1.__decorate([
    Select(ɵ1),
    tslib_1.__metadata("design:type", Observable)
], BottomAnchorComponent.prototype, "currencySignsMap$", void 0);
tslib_1.__decorate([
    Select(ɵ2),
    tslib_1.__metadata("design:type", Observable)
], BottomAnchorComponent.prototype, "addLineItemPending$", void 0);
export { ɵ0, ɵ1, ɵ2 };
